import React, { Fragment } from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux'
import {
    registrarUsuarioAccion, ingresoUsuarioAccion, obtenerTodosLosUsuarios,
    obtenerContador,
    obtenerUserPorEmail,
} from '../../redux/UsuarioDucks'
import { ObtenerClientes, } from '../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { obtenerSolicitudesWithStatus, obetenerSolicitud, Contadorfc_01PorLogin , ObtenerClientePorLogin} from '../../redux/SolicitudesDucks'
import { obtenerTodasLasSolicitudesWithStatusEnviado,obtenerTodosClientes } from '../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import ArrowBackIcon from '@mui/icons-material/ArrowBackRounded';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
import generateStore from '../../redux/store';
import { ThemeProvider, createTheme } from '@mui/system';
import LogoMagueySVG from '../../img/logotipoComercam.svg';
import './Login.css'; { {/*Estilos para el componente*/ } }
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../redux/AppDucks'
import { obtenerCadenaProductivaPorLogin } from '../../redux/DucksBeneficiario/ClienteDucks';
import moment from 'moment'

function Login(props) {

    const dispatch = useDispatch()
    const fechaHoy = moment().format('YYYY-MM-DD')
    const [alert, setAlert] = useStateIfMounted(false)
    const [errorAgregar, setErrorAgregar] = useStateIfMounted(false)
    const [errorLogin, setErrorLogin] = useStateIfMounted(false)
    const [exito, setExito] = useStateIfMounted(false)

    const [registrar, setRegistrar] = useStateIfMounted(false)

    const [usuario, setUsuario] = useStateIfMounted('')
    const [password, setPassword] = useStateIfMounted('')

    const modoRegistro = (value) => {
        setRegistrar(value)
        setAlert(false)
        setExito(false)
        setErrorAgregar(false)
        setErrorLogin(false)
    }

    const reloadPage = () => {
        window.location.reload()
    }
    const [usuarioValido, setUsuarioValido] = useStateIfMounted(false)
    const [contrasenaValido, setContrasenaValido] = useStateIfMounted(false)
    const [usuarioLong, setUsuarioLong] = useStateIfMounted(false)

    const botonRegistrarUsuario = async () => {

        if (usuario === '' || password === '' || usuario.length < 4) {
            if (usuario === '' || usuario.length < 4) setUsuarioValido(true)
            if (password === '') setContrasenaValido(true)
        } else {
            let fechainscripcion = new Date(fechaHoy).toISOString()
            const res = await dispatch(registrarUsuarioAccion({ usuario, password, fechainscripcion }))
            setUsuario('')
            setPassword('')
            setUsuarioValido(false)
            setContrasenaValido(false)
            if (res) {
                setAlert(true)
                setExito(true)
                setRegistrar(false)
                props.history.push('/login')
            } else {
                setAlert(true)
                setErrorAgregar(true)
            }
        }

    }
    const currentUser = useSelector(store => store.Usuario.data)
    const loginIn = localStorage.getItem('user')

    const validarInicioSesion = () => {
        if (currentUser != null && loginIn != null) {
            props.history.push('/solicitudes')
        }
    }


    const theme = createTheme({
        palette: {
            background: {
                button: '#c88b3e',
            }
        }
    });

    const botonLoginUsuario = async () => {

        if (!usuario.trim()) {
        }
        const res = await dispatch(ingresoUsuarioAccion({ usuario, password }))
        setUsuario('')
        setPassword('')
        if (res) {
            setAlert(true)
            setExito(true)
            const respuesta = await dispatch(obtenerTodosLosUsuarios({ usuario: usuario }))

            let idlogin = respuesta.data.data[0].idlogin
            let num = Number(respuesta)
            await dispatch(actualizarLoadingApp_true())

            await dispatch(obtenerUserPorEmail(usuario))
            if (respuesta.data.data[0].idtipousuario === 1) {
                const contadorLogin = await dispatch(Contadorfc_01PorLogin({ idlogin: idlogin }))
                const contadorBorrador = await dispatch(obtenerContador({ idestatusdesolicitudes: 1, idlogin: idlogin }))
                const contadorEnviado = await dispatch(obtenerContador({ idestatusdesolicitudes: 2, idlogin: idlogin }))
                const contadorRevicion = await dispatch(obtenerContador({ idestatusdesolicitudes: 3, idlogin: idlogin }))
                const contadorAceptado = await dispatch(obtenerContador({ idestatusdesolicitudes: 4, idlogin: idlogin }))
                const contadorDenegado = await dispatch(obtenerContador({ idestatusdesolicitudes: 5, idlogin: idlogin }))
                const contadorCorregidas = await dispatch(obtenerContador({ idestatusdesolicitudes: 6, idlogin: idlogin }))
                if (contadorLogin === 0) {
                    props.history.push('/fc_01')
                } else {
                    if (contadorBorrador > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                    if (contadorEnviado > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                    if (contadorRevicion > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 3, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                    if (contadorAceptado > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 4, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                    if (contadorDenegado > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 5, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                    if (contadorCorregidas > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 6, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                }
            }
            if (respuesta.data.data[0].idtipousuario === 2) {
                await dispatch(obtenerTodosClientes())
                const result = await dispatch(obtenerCadenaProductivaPorLogin(idlogin))
                // const cliente = await dispatch(ObtenerClientePorLogin({idlogin:respuesta.data.data[0].idlogin}))
                props.history.push('/solicitudes')

            }
            if (respuesta.data.data[0].idtipousuario === 3) {
                // await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
                props.history.push('/AtencionAClientesComponent')
            }
            if (respuesta.data.data[0].idtipousuario === 7) {
                await dispatch(ObtenerClientes())
                props.history.push('/PanelConsulta')
            }
            if(respuesta.data.data[0].idtipousuario == 9){
                props.history.push('/PanelComprasComponent')
            }
            if(respuesta.data.data[0].idtipousuario == 10){
                props.history.push('/PanelComprasComponent')
            }
            await dispatch(actualizarLoadingApp_false())
        } else {
            setAlert(true)
            setErrorLogin(true)
        }

    }
    const botonRecuperar = async () => {
        // props.history.push('/solicitudes')
    }

    return (

        <Fragment>
            {validarInicioSesion()}

            <div className='container marginTopLogin loginBackGround2'>
                {
                    errorLogin &&
                    alert &&
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        <Alert severity='error' onClose={() => setAlert(false)}>El usuario y la contraseña no son correctos verifique e intenta nuevamente</Alert>
                    </Stack>
                }
                {
                    errorAgregar &&
                    alert &&
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        <Alert severity='error' onClose={() => setAlert(false)}>El usuario y contraseña ya existe</Alert>
                    </Stack>
                }
                {
                    exito &&
                    alert &&
                    <Stack sx={{ width: '100%' }} spacing={4}>
                        <Alert onClose={() => setAlert(false)}>Agregado</Alert>
                    </Stack>
                }

                <div className='row mt-3'>
                    <div className='col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 loginBackGround'>
                        {
                            registrar ? (
                                <div className='row'>
                                    <div className="text-center">
                                        <img className="img-fluid imagenLogin" src={LogoMagueySVG}></img>
                                    </div>
                                </div>
                            ) : (
                                <div className='row'>
                                    <div className="text-center">
                                        <img className="img-fluid imagenLogin" src={LogoMagueySVG}></img>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8 loginBackGround2'>
                        <div className='mt-5 mb-5'>
                            <h1><strong style={{ color: 'white' }}>Bienvenido a su registro en línea</strong></h1>
                            <hr></hr>
                            {
                                registrar === false ? (<h5>Por favor ingrese sus datos de acceso:</h5>) : (<h5>Por favor ingrese sus datos de registro:</h5>)
                            }

                        </div>
                        <div className='container loginBackGround2'>
                            <div className="form-floating text-dark mt-5">
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="name@example.com"
                                    value={usuario}
                                    onChange={e => setUsuario(e.target.value)} />
                                <label className="floatingInput ms-2">Correo electrónico</label>
                                {usuarioValido &&
                                    <span className='text-danger'>El usuario esta vacio o no es correcto, intente nuevamente</span>
                                }

                            </div>
                            <div className="form-floating text-dark mt-2 mb-3">
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)} />
                                <label className="floatingInput ms-2">Contraseña</label>
                                {contrasenaValido &&
                                    <span className='text-danger'>La contraseña esta vacia, ingrese un dato nuevamente</span>
                                }
                            </div>
                        </div>
                        <div className="row mb-4">
                            {
                                registrar ? (
                                    <div className='text-center'>
                                        <button
                                            type='submit'
                                            className='btn botonLogin'
                                            onClick={() => botonRegistrarUsuario()}>Registrar
                                        </button>
                                    </div>

                                ) : (
                                    <Fragment>
                                        <div className='text-center'>
                                            <button
                                                type='submit'
                                                className='btn botonLogin'
                                                onClick={() => botonLoginUsuario()}> Ingresar
                                            </button>

                                        </div>
                                        {/* <div style={{ color: 'white' }} className="mt-3" >
                                            ¿Olvidaste tu contraseña?
                                            <button type='submit'  onClick={()=>botonRecuperar()}> Recuperar</button>
                                        
                                        </div> */}

                                    </Fragment>
                                )
                            }

                        </div>
                        {
                            !registrar &&
                            <div className='row mb-5 mt-3'>
                                <div className='text-center'>
                                    <p>
                                        ¿Aún no tienes una cuenta?
                                        {/* ¿Aún no eres socio? */}
                                    </p>
                                </div>
                                <div className='text-center'>
                                    <button onClick={() => modoRegistro(true)} className='btn botonLogin'>
                                        Registrate</button>
                                </div>
                            </div>
                        }
                        {
                            registrar &&
                            <div className='row mt-3 mb-5'>
                                <div className='text-center'>
                                    <button className='btn botonLogin' onClick={() => modoRegistro(false)}>Volver</button>
                                </div>
                            </div>
                        }

                        <div className='botom loginBackGround2'>
                            <br></br>
                            <p>© {new Date().getFullYear()} COMERCAM. Todos los derechos reservados. Declaración de <a href="https://comercam-dom.org.mx/"><span>Privacidad</span></a></p>
                            <br></br><br></br>
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>

    )
}

export default withRouter(Login)
